import { useFormik } from "formik";
import * as Yup from 'yup';

// Esquema de validación
export const ApproveRequestsValidationSchema = Yup.object({
  reason: Yup.string(),
});

// Hook customizado
interface UseTransferRequestFormikProps {
  onSubmit: (values: any) => void;
}

const useApproveRequestsFormik = ({ onSubmit }: UseTransferRequestFormikProps) => {
  return useFormik({
    initialValues: {
      reason: '',
    },
    validationSchema: ApproveRequestsValidationSchema,
    onSubmit,
  });
};

export default useApproveRequestsFormik;
